import { OfferStatus, OfferItem, OfferBrief } from '@recruitee/http/types';

export enum EntityStoreKey {
  JobsBrief = 'JobsBrief',
  JobItems = 'JobItems',
  TalentPools = 'TalentPoolItems',
  TalentPoolsBrief = 'TalentPoolsBrief',
  TalentPoolsFull = 'TalentPoolsFull',
  JobsFull = 'JobsFull',
  OfferLanguagesSetups = 'OfferLanguagesSetups',
  OffersByCompany = 'OffersByCompany',
  PipelineStages = 'PipelineStages',
  JobRequisitions = 'JobRequisitions',
}

export enum OfferScope {
  Active = 'not_archived',
  Archived = 'archived',
}

export const CanAssignToJobsWithStatuses = [
  OfferStatus.Internal,
  OfferStatus.Published,
  OfferStatus.Closed,
];

export enum StatusChangeType {
  Duplicate = 'duplicate',
  Unarchive = 'unarchive',
  Archive = 'archive',
  Delete = 'delete',
  Publish = 'publish',
  Unpublish = 'unpublish',
  Close = 'close',
  Draft = 'draft',
}

export type UpdateSocialMediaActionPayload = {
  id: number;
  sharingTitle: string;
  sharingDescription: string;
  sharingImage: string | null;
  langCode: string;
};

export type JobsIdMap = Record<number, OfferItem | OfferBrief>;
